import Price from '@/components/money/price'
import { formatNights } from '@/lib/utils'

interface PriceSummaryInlineProps {
  discountPrice: number
  standardPrice?: number
  nights: number
}

/**
 * Displays price summary with nights in an inline format:
 * - Main line: [discounted price] / X nocí
 * - Second line (if discount): [original price] strikethrough
 */
export function PriceSummaryInline({ discountPrice, standardPrice, nights }: PriceSummaryInlineProps) {
  const hasDiscount = standardPrice !== undefined && standardPrice !== discountPrice

  return (
    <div className="flex min-h-12 flex-col justify-center">
      <div className="text-xl font-semibold text-slate-900">
        <Price price={discountPrice} />
        <span className="text-sm font-normal text-slate-900"> za {formatNights(nights)}</span>
      </div>
      {hasDiscount && (
        <div className="text-sm text-slate-400">
          <Price price={standardPrice} className="line-through" />
        </div>
      )}
    </div>
  )
}
